<template>
  <div
    class="p-1 flex items-center justify-between gap-4 rounded bg-pure-white"
  >
    <div class="flex items-center gap-1 truncate" :title="nameString">
      <BlIcon v-if="!checkable" icon="file" color="slate-6" class="h-4 w-4" />
      <input
        v-else
        type="checkbox"
        class="cursor-pointer"
        :checked="checked"
        @change="$emit('check-handler')"
      />
      <a v-if="url" :href="url" target="_blank" class="cursor-pointer truncate">
        <BlTextBody2
          :text="nameString"
          class="underline text-slate-800 font-semibold truncate"
        />
      </a>
      <BlTextBody2
        v-else
        :text="nameString"
        class="underline text-slate-800 font-semibold truncate"
      />
    </div>
    <div class="flex items-center gap-1 flex-shrink-0">
      <BlTextBody2
        v-if="sizeString"
        :text="`${sizeString}`"
        class="flex-shrink-0"
      />
      <div v-if="loading" class="blum-loader-xs"></div>
      <BlIcon
        v-else-if="removeable"
        icon="delete"
        color="slate-6"
        class="h-4 w-4"
        title="Remove"
        clickable
        @clicked="onRemove"
      />
    </div>
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlTextBody2 from "./BlTextBody2.vue";

export default {
  name: "BlFileHolder",
  components: {
    BlIcon,
    BlTextBody2
  },
  props: {
    name: { type: String, required: true },
    size: { type: Number, required: true },
    url: { type: String, default: "" },
    decimals: { type: Number, default: 2 },
    checkable: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    // @check-handler
    removeable: { type: Boolean, default: false }
    // @remove-handler
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    nameString() {
      return this.name || "";
    },
    sizeString() {
      return this.size ? this.byteConverter(this.size, this.decimals) : "";
    }
  },
  methods: {
    onRemove() {
      this.loading = true;
      this.$emit("remove-handler");
      setTimeout(() => {
        this.loading = false;
      }, 5000);
    },
    byteConverter(bytes, decimals, only) {
      const K_UNIT = 1024;
      const SIZES = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

      if (bytes === 0) return "0 Byte";

      if (only === "MB") {
        return (bytes / (K_UNIT * K_UNIT)).toFixed(decimals) + " MB";
      }

      let i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
      let resp =
        parseFloat((bytes / Math.pow(K_UNIT, i)).toFixed(decimals)) +
        " " +
        SIZES[i];

      return resp;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlFileHolder.vue